/* ==========================================================================
   BrickCars - ATC Gamification (Vanilla JS, keine Libraries)

   1) Fly-to-Cart: beim Klick auf "In den Warenkorb" fliegt ein SVG-Auto
      entlang einer quadratischen Bezier-Kurve zum Header-Warenkorb.
   2) Lob-Banner: nach dem Hinzufuegen oben im Cart-Drawer. Bleibt in der
      Session bestehen - auch wenn der Drawer zwischendurch geschlossen wird.
   3) Cross-Sells: Produktzeile im scrollbaren Bereich des Drawers, hinter den
      Warenkorb-Positionen, mit Direkt-Hinzufuegen.
   4) Payment-Icons unter dem Checkout-Button.

   Konfiguration kommt aus window.BCAtcGamify (sections/bc-atc-gamify.liquid).
   Kompatibel mit Dawn 16.0.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- Config */
  var OPT = window.BCAtcGamify || {};

  var CFG = {
    flightBase: Number(OPT.duration) || 700,
    flightMin: 620,
    flightMax: 900,
    steps: 26,
    maxConcurrent: 3,
    bannerMs: Number(OPT.bannerMs) || 0, // 0 = dauerhaft sichtbar
    praiseTtlMs: 30 * 60 * 1000, // solange gilt ein Lob innerhalb der Session
    storeKey: 'bcPraise',
    cartIcon: '#cart-icon-bubble',
    atcSelector: [
      'button[name="add"]',
      '.quick-add__submit',
      'product-form button[type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]'
    ].join(',')
  };

  var MESSAGES = {
    first: [
      { t: 'Starke Wahl! 🏎️💨', s: 'Dein Modell ist auf dem Weg in deine Sammlung.' },
      { t: 'Guter Griff! 🏁', s: 'Dieses Modell macht in jeder Vitrine eine Figur.' }
    ],
    few: [
      { t: 'Die Garage füllt sich! 🧱', s: 'Zwei Modelle an Bord – das passt zusammen.' },
      { t: 'Boxenstopp erfolgreich! 🏁', s: 'Deine Auswahl nimmt Fahrt auf.' }
    ],
    many: [
      { t: 'Sammler-Modus aktiv! 🏆', s: 'Deine Sammlung wächst in Rekordzeit.' },
      { t: 'Volle Startaufstellung! 🚦', s: 'Das wird eine beeindruckende Reihe.' }
    ],
    lots: [
      { t: 'Vollgas, Sammler! 🚀', s: 'Respekt – so sieht eine echte Sammlung aus.' },
      { t: 'Pole Position! 🥇', s: 'Deine Garage spielt in einer eigenen Liga.' }
    ]
  };

  var CAR_SVG =
    '<svg viewBox="0 0 64 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M3.2 23.5h57a3.8 3.8 0 0 0 3.8-3.8v-2.4c0-2.4-1.7-4.4-4-4.9l-13.6-2.8-7-5A9.2 9.2 0 0 0 34 2.8H24.4c-2.2 0-4.3.8-6 2.2l-6.6 5.6-6.6 1.6A5.4 5.4 0 0 0 1 17.4v2.3a3.8 3.8 0 0 0 2.2 3.8z" fill="#91b6b1"/>' +
    '<path d="M25.6 6.2h8.2c1.2 0 2.4.4 3.4 1.1l4.6 3.3H25.6V6.2zM22.6 6.4v4.2h-6.3l3.6-3c.8-.7 1.7-1.1 2.7-1.2z" fill="#f2f6f5"/>' +
    '<path d="M1 17.4h63v2.3a3.8 3.8 0 0 1-3.8 3.8H3.2A3.8 3.8 0 0 1 1 19.7v-2.3z" fill="#6e8e8a"/>' +
    '<circle cx="17.5" cy="23" r="6.2" fill="#121212"/><circle cx="17.5" cy="23" r="2.5" fill="#e9eeed"/>' +
    '<circle cx="47.5" cy="23" r="6.2" fill="#121212"/><circle cx="47.5" cy="23" r="2.5" fill="#e9eeed"/>' +
    '</svg>';

  var FLAG_SVG =
    '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
    '<path d="M4 2v20" stroke="#121212" stroke-width="2.4" stroke-linecap="round" fill="none"/>' +
    '<path d="M7 3h4v4H7zM11 7h4v4h-4zM15 3h4v4h-4zM7 11h4v4H7zM15 11h4v4h-4z" fill="#121212"/>' +
    '</svg>';

  if (OPT.enabled === false) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var flying = 0;
  var bannerTimer = null;
  var syncing = false;

  /* ------------------------------------------------------------ 1) Flight */

  function easeInOutCubic(p) {
    return p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
  }

  function cartTarget() {
    var el = document.querySelector(CFG.cartIcon);
    if (el) {
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.bottom > 0 && r.top < window.innerHeight) {
        return { x: r.left + r.width / 2, y: r.top + r.height / 2, el: el };
      }
    }
    return { x: window.innerWidth - 34, y: 38, el: el || null };
  }

  function flyToCart(fromEl) {
    if (reduceMotion.matches) return;
    if (flying >= CFG.maxConcurrent) return;
    if (typeof Element === 'undefined' || !Element.prototype.animate) return;

    var r = fromEl.getBoundingClientRect();
    if (!r.width && !r.height) return;

    var start = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    var target = cartTarget();
    var end = { x: target.x, y: target.y };

    var dx = end.x - start.x;
    var dy = end.y - start.y;
    var dist = Math.sqrt(dx * dx + dy * dy);
    if (dist < 24) return;

    var lift = Math.min(300, Math.max(90, dist * 0.45));
    var ctrl = {
      x: (start.x + end.x) / 2 + (dx >= 0 ? -dist * 0.1 : dist * 0.1),
      y: Math.min(start.y, end.y) - lift
    };

    var duration = Math.min(CFG.flightMax, Math.max(CFG.flightMin, CFG.flightBase * (0.75 + dist / 1600)));

    var car = document.createElement('div');
    car.className = 'bc-fly-car';
    car.setAttribute('aria-hidden', 'true');
    car.innerHTML = CAR_SVG;
    document.body.appendChild(car);
    flying++;

    var halfW = car.offsetWidth / 2 || 23;
    var halfH = car.offsetHeight / 2 || 12;

    var frames = [];
    var prev = null;
    for (var i = 0; i <= CFG.steps; i++) {
      var p = i / CFG.steps;
      var t = easeInOutCubic(p);
      var mt = 1 - t;
      var x = mt * mt * start.x + 2 * mt * t * ctrl.x + t * t * end.x;
      var y = mt * mt * start.y + 2 * mt * t * ctrl.y + t * t * end.y;

      var rot = 0;
      if (prev) {
        rot = ((Math.atan2(y - prev.y, x - prev.x) * 180) / Math.PI) * 0.4;
        rot = Math.max(-20, Math.min(20, rot));
      }
      prev = { x: x, y: y };

      var scale = 0.55 + 0.55 * Math.sin(Math.PI * Math.min(p * 1.15, 1));
      if (p > 0.72) scale *= 1 - (p - 0.72) * 1.9;
      scale = Math.max(0.28, scale);

      frames.push({
        offset: p,
        opacity: p < 0.06 ? p / 0.06 : p > 0.9 ? Math.max(0, (1 - p) / 0.1) : 1,
        transform:
          'translate3d(' + (x - halfW).toFixed(2) + 'px,' + (y - halfH).toFixed(2) + 'px,0)' +
          ' rotate(' + rot.toFixed(2) + 'deg) scale(' + scale.toFixed(3) + ')'
      });
    }

    var anim = car.animate(frames, { duration: duration, easing: 'linear', fill: 'forwards' });

    var finished = false;
    var done = function () {
      if (finished) return;
      finished = true;
      if (car.parentNode) car.parentNode.removeChild(car);
      flying = Math.max(0, flying - 1);
      var icon = target.el || document.querySelector(CFG.cartIcon);
      if (icon) {
        icon.classList.remove('bc-cart-pop');
        void icon.offsetWidth;
        icon.classList.add('bc-cart-pop');
        setTimeout(function () {
          icon.classList.remove('bc-cart-pop');
        }, 500);
      }
    };

    anim.onfinish = done;
    anim.oncancel = done;
    setTimeout(done, duration + 400);
  }

  /* -------------------------------------------------------- 2) Lob-Banner */

  // Das Lob liegt in der sessionStorage, damit es das Schliessen und erneute
  // Oeffnen des Drawers ueberlebt (und jeden Re-Render des Drawer-Markups).
  function loadPraise() {
    try {
      var raw = sessionStorage.getItem(CFG.storeKey);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.t) return null;
      if (Date.now() - (data.at || 0) > CFG.praiseTtlMs) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function savePraise(msg) {
    try {
      sessionStorage.setItem(CFG.storeKey, JSON.stringify({ t: msg.t, s: msg.s, at: Date.now() }));
    } catch (e) {
      /* Private Mode o. ae. */
    }
  }

  function clearPraise() {
    try {
      sessionStorage.removeItem(CFG.storeKey);
    } catch (e) {
      /* ignore */
    }
  }

  function cartCount() {
    var bubble = document.querySelector(CFG.cartIcon + ' .cart-count-bubble span[aria-hidden="true"]');
    var n = bubble ? parseInt(bubble.textContent.trim(), 10) : NaN;
    return isNaN(n) ? 1 : n;
  }

  function pickMessage(count) {
    var pool = count <= 1 ? MESSAGES.first : count <= 2 ? MESSAGES.few : count <= 4 ? MESSAGES.many : MESSAGES.lots;
    var prev = loadPraise();
    var choice = pool[Math.floor(Math.random() * pool.length)];
    if (pool.length > 1 && prev && choice.t === prev.t) {
      choice = pool[(pool.indexOf(choice) + 1) % pool.length];
    }
    return choice;
  }

  function buildBanner() {
    var el = document.createElement('div');
    el.className = 'bc-praise';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="bc-praise__icon" aria-hidden="true">' + FLAG_SVG + '</span>' +
      '<span class="bc-praise__body">' +
      '<strong class="bc-praise__title"></strong>' +
      '<span class="bc-praise__text"></span>' +
      '</span>';
    return el;
  }

  function drawerInner() {
    return document.querySelector('#CartDrawer .drawer__inner');
  }

  function cartIsEmpty() {
    var drawer = document.querySelector('cart-drawer');
    return !!(drawer && drawer.classList.contains('is-empty'));
  }

  // Stellt sicher, dass das Banner mit dem gespeicherten Lob im aktuellen
  // Drawer-Markup haengt. Idempotent - mehrfaches Aufrufen kostet nichts.
  function syncBanner() {
    var praiseData = loadPraise();
    var inner = drawerInner();
    if (!inner) return;

    var el = inner.querySelector(':scope > .bc-praise');

    if (!praiseData || cartIsEmpty()) {
      if (el && el.parentNode) el.parentNode.removeChild(el);
      return;
    }

    var isNew = false;
    if (!el) {
      el = buildBanner();
      isNew = true;
      var header = inner.querySelector('.drawer__header');
      if (header && header.nextSibling) {
        inner.insertBefore(el, header.nextSibling);
      } else if (header) {
        inner.appendChild(el);
      } else {
        inner.insertBefore(el, inner.firstChild);
      }
    }

    var title = el.querySelector('.bc-praise__title');
    var text = el.querySelector('.bc-praise__text');
    var wantTitle = OPT.customTitle || praiseData.t;
    var wantText = OPT.customText || praiseData.s;
    if (title && title.textContent !== wantTitle) title.textContent = wantTitle;
    if (text && text.textContent !== wantText) text.textContent = wantText;

    if (isNew || !el.classList.contains('is-in')) {
      el.classList.remove('is-out');
      // Reflow erzwingen, damit der Startzustand committed ist und die
      // Transition wirklich laeuft (zuverlaessiger als requestAnimationFrame,
      // das in Hintergrund-Tabs pausiert wird).
      void el.offsetWidth;
      el.classList.add('is-in');
    }

    clearTimeout(bannerTimer);
    if (CFG.bannerMs > 0) {
      bannerTimer = setTimeout(function () {
        clearPraise();
        el.classList.remove('is-in');
        el.classList.add('is-out');
        setTimeout(function () {
          if (el.parentNode) el.parentNode.removeChild(el);
        }, 320);
      }, CFG.bannerMs);
    }
  }

  function praise() {
    savePraise(pickMessage(cartCount()));
    syncAll();
  }

  /* ------------------------------------------------------- 3) Cross-Sells */

  function xsellTemplate() {
    var tpl = document.getElementById('bc-xsell-template');
    return tpl && tpl.content ? tpl.content.querySelector('.bc-xsell') : null;
  }

  function variantsInCart() {
    var ids = {};
    var inputs = document.querySelectorAll('#CartDrawer [data-quantity-variant-id]');
    for (var i = 0; i < inputs.length; i++) {
      ids[inputs[i].getAttribute('data-quantity-variant-id')] = true;
    }
    return ids;
  }

  // Blendet Produkte aus, die schon im Warenkorb liegen. Laeuft nach jedem
  // Drawer-Render neu, weil sich der Warenkorb-Inhalt geaendert haben kann.
  function filterXsell(block) {
    var inCart = variantsInCart();
    var items = block.querySelectorAll('.bc-xsell__item');
    var visible = 0;
    for (var i = 0; i < items.length; i++) {
      var hide = !!inCart[items[i].getAttribute('data-variant-id')];
      if (items[i].hidden !== hide) items[i].hidden = hide;
      if (!hide) visible++;
    }
    var empty = visible === 0;
    if (block.hidden !== empty) block.hidden = empty;
  }

  function syncXsell() {
    var source = xsellTemplate();
    var inner = drawerInner();
    if (!inner) return;

    var block = inner.querySelector('.bc-xsell');

    if (!source || cartIsEmpty()) {
      if (block && block.parentNode) block.parentNode.removeChild(block);
      return;
    }

    if (!block) {
      block = source.cloneNode(true);
      // In den scrollbaren Bereich haengen (hinter die Warenkorb-Positionen),
      // damit die eigenen Produkte oben stehen und nicht von den Empfehlungen
      // aus dem sichtbaren Bereich gedrueckt werden.
      var scroller = inner.querySelector('cart-drawer-items');
      if (scroller) {
        scroller.appendChild(block);
      } else {
        var footer = inner.querySelector('.drawer__footer');
        if (footer) {
          inner.insertBefore(block, footer);
        } else {
          inner.appendChild(block);
        }
      }
    }

    filterXsell(block);
  }

  function xsellAdd(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;

    var drawer = document.querySelector('cart-drawer');
    var sections = 'cart-drawer,cart-icon-bubble';
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      sections = drawer
        .getSectionsToRender()
        .map(function (s) {
          // Dawn liefert je nach Version nur { id, selector } ohne section
          return s.section || s.id;
        })
        .join(',');
    }

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');

        if (data && data.status) {
          // z. B. ausverkauft - Dawn-typische Fehlerantwort
          btn.classList.add('is-error');
          setTimeout(function () {
            btn.classList.remove('is-error');
          }, 2000);
          return;
        }

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        }

        savePraise(pickMessage(cartCount()));

        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bc-xsell',
            productVariantId: id,
            cartData: data
          });
        }
        syncAll();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-error');
        setTimeout(function () {
          btn.classList.remove('is-error');
        }, 2000);
      });
  }

  /* --------------------------------------------------- 4) Payment-Icons */

  function payTemplate() {
    var tpl = document.getElementById('bc-pay-template');
    return tpl && tpl.content ? tpl.content.querySelector('.bc-pay') : null;
  }

  // Haengt die Icons unter den Checkout-Button - im Drawer und auf der
  // Warenkorb-Seite. Beide Container rendert Dawn bei Updates neu.
  function syncPay() {
    var source = payTemplate();
    if (!source) return;

    var roots = [document.getElementById('CartDrawer'), document.getElementById('main-cart-footer')];

    for (var i = 0; i < roots.length; i++) {
      if (!roots[i]) continue;
      var ctas = roots[i].querySelector('.cart__ctas');
      if (!ctas || !ctas.parentNode) continue;
      var host = ctas.parentNode;
      if (host.querySelector(':scope > .bc-pay')) continue;
      host.appendChild(source.cloneNode(true));
    }
  }

  /* ------------------------------------------------------------ Sync-Loop */

  // Dawn ersetzt #CartDrawer bei jedem Cart-Update komplett. Ein einzelner
  // Observer haelt Banner, Cross-Sells und Payment-Icons im aktuellen Markup.
  function syncAll() {
    if (syncing) return;
    syncing = true;
    try {
      // Nur aufraeumen, wenn der Warenkorb wirklich leer ist - direkt nach dem
      // Add traegt der Drawer noch die alte Klasse is-empty, das Lob ist dann
      // erst Millisekunden alt und darf nicht verworfen werden.
      var stored = loadPraise();
      if (cartIsEmpty() && stored && Date.now() - (stored.at || 0) > 2000) clearPraise();
      syncBanner();
      syncXsell();
      syncPay();
    } finally {
      syncing = false;
    }
  }

  function observeTargets() {
    var observer = new MutationObserver(function () {
      syncAll();
    });
    var targets = [document.querySelector('cart-drawer')];

    // Warenkorb-Seite: dort rendert Dawn main-cart-footer neu, nicht den Drawer.
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter && cartFooter.parentNode) targets.push(cartFooter.parentNode);

    for (var i = 0; i < targets.length; i++) {
      if (!targets[i]) continue;
      observer.observe(targets[i], {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  /* ------------------------------------------------------------- Bindings */

  // Flug sofort beim Klick starten. Capture-Phase, damit Dawn-Handler
  // unberuehrt bleiben.
  document.addEventListener(
    'click',
    function (evt) {
      var btn = evt.target && evt.target.closest ? evt.target.closest(CFG.atcSelector) : null;
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      if (btn.closest('cart-drawer, #CartDrawer, .cart__contents')) return;
      flyToCart(btn);
    },
    true
  );

  // Cross-Sell-Buttons
  document.addEventListener('click', function (evt) {
    if (!evt.target || !evt.target.closest) return;
    var btn = evt.target.closest('[data-bc-xsell-add]');
    if (!btn) return;
    evt.preventDefault();
    xsellAdd(btn);
  });

  if (typeof window.subscribe === 'function') {
    var evtName =
      typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate ? PUB_SUB_EVENTS.cartUpdate : 'cart-update';
    window.subscribe(evtName, function (payload) {
      if (payload && payload.source === 'bc-xsell') return; // schon selbst behandelt
      if (payload && payload.source && payload.source !== 'product-form') {
        // Menge geaendert oder Position entfernt: nur nachziehen, nicht neu loben
        syncAll();
        return;
      }
      // Dawn publisht je nach Pfad vor dem Re-Render. Kurz warten, damit die
      // Warenkorb-Bubble aktuell ist (bestimmt die Stufe des Lob-Textes);
      // der Observer zieht das Markup danach ohnehin nach.
      syncAll();
      setTimeout(praise, 80);
    });
  } else if (window.fetch) {
    // Fallback, falls pubsub.js fehlt
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url2 = typeof input === 'string' ? input : input && input.url ? input.url : '';
      var promise = nativeFetch.apply(this, arguments);
      if (url2 && url2.indexOf('/cart/add') !== -1) {
        promise.then(function (res) {
          if (res && res.ok) setTimeout(praise, 250);
          return res;
        });
      }
      return promise;
    };
  }

  function boot() {
    observeTargets();
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
